<!--
 * @FilePath: /daren-html-source/src/components/DeleteDia/index.vue
 * @Description: 删除弹框
-->
<template>
  <el-dialog
    title="提示"
    :visible.sync="isShow"
    width="480px"
    custom-class="noticeDialog"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <div class="dialog-body">
      <div class="title">提现调整</div>
      <div class="font onepad">支付宝提现现已改为闪速收款模式，在平台发起支付后您将在支付宝收到消息推送，首次提现需要在支付宝搜索“闪速收款”登记相关信息，请在48小时内完成操作，逾期未操作款项将退回，如遇到收款问题可以咨询客服。</div>
      <div class="font2">由于支付宝限制，每人每月只支持9笔支付宝提现，请合理规划提现。</div>
      <div class="font">谢谢您对于CloudMaster的理解与支持。</div>
      <div class="checkBox">
        <div class="box" @click="check">
          <svg-btn
            class="checkSvg"
            :icon-class="iconType ? 'icon-check-yes' : 'icon-check-no'"
          />
          <span class="font3">我已开通支付宝闪速收款</span>
        </div>
      </div>
      <div class="footer">
        <fm-button :disabled="!iconType" @click="confirm" type="primary" size="small"
          >知道了</fm-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'NoticePay',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      iconType: false,
    }
  },
  methods: {
    //点击勾选图标，取反
    check() {
      this.iconType = !this.iconType
    },
    handleClose() {
      this.$emit('handleClose')
    },
    confirm() {
      if(!this.iconType){
        return
      }
      this.handleClose()
      this.$emit('confirm')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .noticeDialog {
  .el-dialog__body {
    padding: 20px 21px 32px 24px;
    .dialog-body {
      display: flex;
      flex-direction: column;
      .title {
        font-weight: 500;
        font-size: 16px;
        color: #2c2c2c;
        line-height: 24px;
        text-align: center;
        margin-bottom: 20px;
      }
      .font {
        font-weight: 400;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 22px;
        margin-bottom: 8px;
        text-align: left;
      }
      .font2{
        font-weight: 400;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 22px;
        margin-bottom: 8px;
        text-align: left;
        white-space: nowrap;
      }
      .onepad{
        padding-right: 5px;
      }
      .checkBox {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 16px;
        .box {
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          .checkSvg {
            width: 16px;
            height: 16px;
            margin-right: 8px;
          }
          .font3 {
            font-weight: 400;
            font-size: 14px;
            color: #2c2c2c;
            line-height: 22px;
          }
        }
      }
      .footer {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        .fm-button-small {
          padding: 8px 56px;
          height: 40px;
          span {
            font-weight: 500;
            font-size: 16px;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
    }
  }
}
.d-content {
  margin: 34px 0 24px 0;
  text-align: center;
  font-size: 16px;
}
</style>
